import React from "react";
import PropTypes from "prop-types";

export function DataValue({ value, label, defaultValue }) {
  const placeholder = defaultValue || `Sin ${label?.toLowerCase() || "valor"}`;
  return (
    <div className="sm:col-span-1">
      {label && <h3 className="text-sm font-medium text-gray-500">{label}</h3>}
      {value ? (
        <p className="mt-1 text-sm text-gray-900 font-normal">{value}</p>
      ) : (
        <p className="mt-1 text-sm font-normal text-gray-500">{placeholder}</p>
      )}
    </div>
  );
}

DataValue.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
  label: PropTypes.string,
  defaultValue: PropTypes.string,
};
